import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'replaceEmptyWithString',
})
export class ReplaceEmptyWithStringPipe implements PipeTransform {
  transform(value: unknown, replacement: string): unknown {
    if (value === '' || value === undefined || value === null) {
      return replacement
    } else {
      return value
    }
  }
}
